import styled, { css } from 'styled-components';

import { themeVal, glsp } from '@devseed-ui/theme-provider';

const renderDividerVariation = ({ variation }) => {
  if (variation === 'light') {
    return css`
      background: transparent
        linear-gradient(
          90deg,
          ${themeVal('color.surface-100a')},
          ${themeVal('color.surface-100a')}
        )
        50% / ${themeVal('layout.border')} auto no-repeat;
    `;
  }

  // Default: variation === 'dark'
  return css`
    background: transparent
      linear-gradient(
        90deg,
        ${themeVal('color.base-200a')},
        ${themeVal('color.base-200a')}
      )
      50% / ${themeVal('layout.border')} auto no-repeat;
  `;
};

export const VerticalDivider = styled.hr`
  display: inline-flex;
  border: 0;
  width: ${glsp(1 / 2)};
  height: ${glsp()};
  margin: 0;

  ${renderDividerVariation}
`;
